module.exports = __webpack_public_path__ + "static/media/1350_ItemSelection_GiftShop_step2.ccc9bbf4.png";